<section class="page">
  <div class="page__header">
    <h1>Utilisateurs</h1>
    <spw-button variant="primary" [disabled]="isSubmitting" (click)="createUser()">
      {{ isSubmitting ? 'Création...' : 'Créer' }}
    </spw-button>
  </div>

  <spw-message
    *ngIf="successMessage"
    [messageTitle]="'Succès'"
    variant="success"
    [isDismissable]="true"
    [dismissableText]="'Fermer'"
  >
    {{ successMessage }}
  </spw-message>
  <spw-message
    *ngIf="errorMessage"
    [messageTitle]="'Erreur'"
    variant="alert"
    [isDismissable]="true"
    [dismissableText]="'Fermer'"
  >
    {{ errorMessage }}
  </spw-message>

  <div class="form">
    <spw-text-field
      label="Prénom"
      name="prenom"
      [value]="form.prenom"
      placeholder="Prénom"
      (valueChanged)="form.prenom = '' + $event.detail"
    ></spw-text-field>
    <spw-text-field
      label="Nom"
      name="nom"
      [value]="form.nom"
      placeholder="Nom"
      (valueChanged)="form.nom = '' + $event.detail"
    ></spw-text-field>
    <spw-text-field
      label="Email"
      name="email"
      type="email"
      [value]="form.email"
      placeholder="Email"
      (valueChanged)="form.email = '' + $event.detail"
    ></spw-text-field>
    <spw-text-field
      label="Mot de passe"
      name="password"
      type="password"
      [value]="form.password"
      placeholder="Mot de passe"
      (valueChanged)="form.password = '' + $event.detail"
    ></spw-text-field>
    <div class="form-field">
      <spw-field-label label="Rôle"></spw-field-label>
      <select [(ngModel)]="form.role" class="native-select">
        <option value="USER">USER</option>
        <option value="ADMIN">ADMIN</option>
      </select>
    </div>
    <div class="form-field">
      <spw-field-label label="Plateau"></spw-field-label>
      <select [(ngModel)]="form.plateauId" class="native-select">
        <option *ngFor="let plateau of plateaux" [ngValue]="plateau.id">
          {{ plateau.name }}
        </option>
      </select>
    </div>
  </div>

  <div class="edit" *ngIf="selectedUser">
    <h2>Modifier {{ selectedUser.prenom }} {{ selectedUser.nom }}</h2>
    <div class="form">
      <spw-text-field
        label="Prénom"
        name="editPrenom"
        [value]="editForm.prenom"
        placeholder="Prénom"
        (valueChanged)="editForm.prenom = '' + $event.detail"
      ></spw-text-field>
      <spw-text-field
        label="Nom"
        name="editNom"
        [value]="editForm.nom"
        placeholder="Nom"
        (valueChanged)="editForm.nom = '' + $event.detail"
      ></spw-text-field>
      <spw-text-field
        label="Email"
        name="editEmail"
        type="email"
        [value]="editForm.email"
        placeholder="Email"
        (valueChanged)="editForm.email = '' + $event.detail"
      ></spw-text-field>
      <spw-text-field
        label="Nouveau mot de passe"
        name="editPassword"
        type="password"
        [value]="editForm.password"
        placeholder="Nouveau mot de passe"
        (valueChanged)="editForm.password = '' + $event.detail"
      ></spw-text-field>
      <div class="form-field">
        <spw-field-label label="Rôle"></spw-field-label>
        <select [(ngModel)]="editForm.role" class="native-select">
          <option value="USER">USER</option>
          <option value="ADMIN">ADMIN</option>
        </select>
      </div>
      <div class="form-field">
        <spw-field-label label="Plateau"></spw-field-label>
        <select [(ngModel)]="editForm.plateauId" class="native-select">
          <option *ngFor="let plateau of plateaux" [ngValue]="plateau.id">
            {{ plateau.name }}
          </option>
        </select>
      </div>
      <spw-checkbox
        name="editActive"
        [checked]="editForm.active"
        (spwChange)="editForm.active = $event.detail"
      >
        Actif
      </spw-checkbox>
    </div>
    <div class="edit__actions">
      <spw-button variant="primary" [disabled]="isUpdating" (click)="updateUser()">
        {{ isUpdating ? 'Mise à jour...' : 'Enregistrer' }}
      </spw-button>
      <spw-button variant="secondary" (click)="cancelEdit()">Annuler</spw-button>
    </div>
  </div>

  <spw-table>
    <spw-table-head>
      <spw-table-row>
        <spw-table-header>Prénom</spw-table-header>
        <spw-table-header>Nom</spw-table-header>
        <spw-table-header>Email</spw-table-header>
        <spw-table-header>Rôle</spw-table-header>
        <spw-table-header>Actif</spw-table-header>
        <spw-table-header>Plateau</spw-table-header>
        <spw-table-header>Actions</spw-table-header>
      </spw-table-row>
    </spw-table-head>
    <spw-table-body>
      <spw-table-row *ngFor="let user of users">
        <spw-table-cell>{{ user.prenom }}</spw-table-cell>
        <spw-table-cell>{{ user.nom }}</spw-table-cell>
        <spw-table-cell>{{ user.email }}</spw-table-cell>
        <spw-table-cell>{{ user.role }}</spw-table-cell>
        <spw-table-cell>{{ user.active ? 'Oui' : 'Non' }}</spw-table-cell>
        <spw-table-cell>{{ getPlateauName(user.plateauId) }}</spw-table-cell>
        <spw-table-cell>
          <div class="row-actions">
            <spw-button variant="secondary" size="small" (click)="startEdit(user)">Modifier</spw-button>
            <spw-button variant="tertiary" size="small" [disabled]="deletingUserId === user.id" (click)="deleteUser(user)">
              {{ deletingUserId === user.id ? 'Suppression...' : 'Supprimer' }}
            </spw-button>
          </div>
        </spw-table-cell>
      </spw-table-row>
    </spw-table-body>
  </spw-table>
  <div class="empty" *ngIf="users.length === 0">Aucun utilisateur pour le moment.</div>
</section>
